import { gql } from '@apollo/client';

const SEARCH_QUERY = gql`
    query Search($params: SearchParams!, $limit: Int, $location: LocationInput, $cursor: String) {
        search(params: $params, limit: $limit, location: $location, cursor: $cursor) {
            cursor
            filterTotal
            results {
                acres
                auctionDate
                auctionLatitude
                auctionLongitude
                auctionType
                auctioneer
                auctioneerAddress
                auctioneerCity
                auctioneerDescription
                auctioneerState
                auctioneerUrl
                auctioneerZip
                category
                city
                distance
                drive
                featured
                gallon
                horsepower
                hours
                id
                images
                latitude
                length
                listPrice
                longitude
                make
                makeId
                makeImageUrl
                miles
                model
                modelId
                numberOfBottoms
                numberOfRows
                numberOfShanks
                price
                rearPTO
                seller
                sellerType
                separatorHours
                serial
                spacing
                state
                subcategory
                ton
                vin
                widthFeet
                widthInches
                year
                zip
            }
        }
    }
`;

export default SEARCH_QUERY;
